import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-layout">
        <span>
          © {new Date().getFullYear()} Vuzenik Technologies. All rights
          reserved.
        </span>
        <span>Engineering that reimagines tomorrow.</span>
      </div>
    </footer>
  );
}

export default Footer;
